import React from 'react';
import background from '../../assets/weather_bg.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoWeather extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="ATMOSPHERE"
        description="Weather"
        paragraph="The Arctic is the northernmost region of our planet, rich in biodiversity and resources. Its white surface helps regulate our climate by reflecting solar energy."
        coverbackground={background}
     />
  
  );
 }
}   

export default InfoWeather;